import { z } from 'zod'
import { UTCMillisecondsSchema } from '../time'
import { NotificationSourceSchema } from './source'
import { NotificationRefsSchema, NotificationFactsSchema } from './refs'
import { NotificationIdSchema } from './id'
import { NotificationDisplaySchema } from './display'
import { NotificationDestinationTargetSchema } from './destination'

export const NotificationTopicSchema = z.enum(['areas', 'events', 'meetings', 'recordings'])
export const NotificationTypeSchema = z.enum([
  'area.assigned',
  'area.unassigned',
  'accounts.assigned',
  'event.set',
  'event.rescheduled',
  'event.reassigned',
  'event.cancelled',
  'event.outcome',
  'event.dispatch',
  'event.closerUnavailable',
  'meeting.reminder',
  'meeting.nudge',
  'recording.flagged',
])
export const NotificationViewSchema = z.enum(['inbox', 'unread', 'archived'])
export type NotificationTopic = z.infer<typeof NotificationTopicSchema>
export type NotificationType = z.infer<typeof NotificationTypeSchema>
export type NotificationView = z.infer<typeof NotificationViewSchema>

export const NotificationItemSchema = z.object({
  id: NotificationIdSchema,
  createdAt: UTCMillisecondsSchema,
  topic: NotificationTopicSchema,
  type: NotificationTypeSchema,
  state: z.object({ readAt: UTCMillisecondsSchema.nullable(), archivedAt: UTCMillisecondsSchema.nullable() }),
  expiresAt: UTCMillisecondsSchema.nullable(),
  expired: z.boolean(),
  // Supplied only after current viewer permission checks; absent on older servers.
  muteSource: NotificationSourceSchema.nullable().optional(),
  refs: NotificationRefsSchema,
  facts: NotificationFactsSchema,
  display: NotificationDisplaySchema,
  // The stored target only; each platform resolves its own URL.
  destination: NotificationDestinationTargetSchema.nullable(),
})
export type NotificationItem = z.infer<typeof NotificationItemSchema>
